module.exports = __webpack_public_path__ + "static/media/game-cvinterviewericon13.72486cb9.png";